import React, { useRef, useEffect } from 'react';
import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';
import { Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import Hero from './Hero';
import TabsNav from './TabsNav';
import SubHero from './SubHero';
import Definition from './Definition';
import Importance from './Importance';
import Examples from './Examples';
import Benefits from '../Benefits';
import HowParaphrase from './HowParaphrase';
import FourRs from './FourRs';
import Types from './Types';
import Plagiarism from './Plagiarism';
import Comparison from './Comparison';
import BenefitsBlock from './Benefits';

const useStyles = makeStyles((theme) => ({
  tabsWrapper: {},
  tabsWrapperFixed: {
    height: 56,
  },
}));

export default function ParaphraserPillar() {
  const [tabsFixed, setTabsFixed] = React.useState(false);
  const subHeroSection = useRef<HTMLDivElement>(null);
  const [activeSection, setActiveSection] = React.useState('definition');
  const definition = useRef<HTMLDivElement>(null);
  const importance = useRef<HTMLDivElement>(null);
  const examples = useRef<HTMLDivElement>(null);
  const benefits = useRef<HTMLDivElement>(null);
  const how = useRef<HTMLDivElement>(null);
  const plagiarism = useRef<HTMLDivElement>(null);
  const comparison = useRef<HTMLDivElement>(null);
  const classes = useStyles();

  const pillarMapping = [
    {
      value: importance,
      tab: 'importance',
      redirect: 'definition',
    },
    {
      value: examples,
      tab: 'examples',
      redirect: 'importance',
    },
    {
      value: benefits,
      tab: 'benefits',
      redirect: 'examples',
    },
    {
      value: how,
      tab: 'how',
      redirect: 'benefits',
    },
    {
      value: plagiarism,
      tab: 'plagiarism',
      redirect: 'how',
    },
    {
      value: comparison,
      tab: 'comparison',
      redirect: 'plagiarism',
    },
  ];

  const platform = useSelector((rootState: RootState) => rootState?.common?.platform);

  const stickTabs = () => {
    if ((subHeroSection.current?.getBoundingClientRect()?.bottom || 0) <= 50) {
      setTabsFixed(true);
    }

    if ((subHeroSection.current?.getBoundingClientRect()?.bottom || 0) > 50) {
      setTabsFixed(false);
    }

    for (let i = 0; i < pillarMapping.length; i += 1) {
      if ((pillarMapping[i].value.current?.getBoundingClientRect()?.top || 0) > 110) {
        setActiveSection(pillarMapping[i].redirect);
        break;
      } else {
        setActiveSection('comparison');
      }
    }
  };

  const tabBtnClick = (e: React.MouseEvent, tab: string) => {
    // if (platform.isIE) {
    //   window.scrollTo(0, Number(tabsWrapper.current?.offsetTop));
    // } else {
    // }

    // window.scrollTo({
    //   top: tab.current?.offsetTop,
    //   behavior: 'smooth',
    // });

    let scroll = definition;

    setActiveSection(tab);

    for (let i = 0; i < pillarMapping.length; i += 1) {
      if (pillarMapping[i].tab === tab) {
        scroll = pillarMapping[i].value;
        break;
      }
    }

    window.scrollTo({
      top: (scroll.current?.offsetTop || 0) - 55,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', stickTabs);
    return () => {
      window.removeEventListener('scroll', stickTabs);
    };
  }, []);

  return (
    <>
      <div>
        <Hero />
        <div ref={subHeroSection}>
          <SubHero />
        </div>
        {/* <div className={`${classes.tabsWrapper} ${tabsFixed && classes.tabsWrapperFixed}`}> */}
        {/* <div ref={tabBar}> */}
        <TabsNav
          tabsFixed={tabsFixed}
          activeSection={activeSection}
          clickHandler={(e, tab) => tabBtnClick(e, tab)}
        />
        {/* </div> */}
        {/* </div> */}
        <div ref={definition}>
          <Definition />
        </div>
        <div ref={importance}>
          <Importance />
        </div>
        <div ref={examples}>
          <Examples />
        </div>
        <div ref={benefits}>
          <BenefitsBlock />
        </div>
        <div ref={how}>
          <HowParaphrase />
        </div>
        <FourRs />
        <Types />
        <div ref={plagiarism}>
          <Plagiarism />
        </div>
        <div ref={comparison}>
          <Comparison />
        </div>
      </div>
    </>
  );
}
